import React from 'react'

import { Link } from 'react-router-dom'

import './styles.css'

function ContestItem({ id, title, categoria }) {
  return (
    <li id="contest-item-content">
      <div className="info-content">
        <span className='title'>{title}</span>
        <span className='body-text-item'>{categoria}</span>
        <div className="content-link-item">
          <Link to={`/admin/contest/${id}`}>Visualizar</Link>
        </div>
      </div>
      
    </li>
  )
}

export default ContestItem